export default __webpack_public_path__ + "static/media/ITRealCase1-en.637859a6.jpg";